import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { resizeFrame } from '../../actions/project/resizable'
import findMaxOrMinFrame from '../../utils/findMaxOrMinFrame'
import ResizableProduct from './../../components/ResizableProduct'

const mapStateToProps = state => ({
  perMeter: dotProp.get(state, 'project.background.perMeter', 1000),
  minSize: findMaxOrMinFrame(dotProp.get(state, 'products.images', [])),
  maxSize: findMaxOrMinFrame(dotProp.get(state, 'products.images', []), false),
  isResizing: dotProp.get(state, 'products.isResizing', false),
  allowToResize: dotProp.get(state, 'project.allowToResize', false),
})

const mapDispatchToProps = dispatch => ({
  onResize: (index, size, isFinish = true, pos) => dispatch(resizeFrame(index, size, isFinish, pos)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResizableProduct)



// WEBPACK FOOTER //
// ./src/containers/ResizableProduct/index.js